export const environment = {
  production: true,
  pathFr: "contribution-logements",
  pathEn: "en/housing-contribution",
  linkUsageFr:
    "https://montreal.ca/articles/metropole-mixte-utiliser-loutil-de-calcul-7813",
  linkUsageEn:
    "https://montreal.ca/en/articles/diverse-metropolis-use-calculation-tool-7813",
  linkRulesFr:
    "https://montreal.ca/articles/metropole-mixte-les-grandes-lignes-du-reglement",
  linkRulesEn:
    "https://montreal.ca/en/articles/diverse-metropolis-overview-law",
  linkHelpFr:
    "https://montreal.ca/articles/metropole-mixte-utiliser-loutil-de-calcul",
  linkHelpEn:
    "https://montreal.ca/en/articles/diverse-metropolis-use-calculation-tool",
  linkHomeEn: "https://montreal.ca/en/",
  linkHomeFr: "https://montreal.ca/",
  linkServicesEn: "https://montreal.ca/en/services",
  linkServicesFr: "https://montreal.ca/services",
  linkToolsEn:
    "https://montreal.ca/en/services?mtl_content.services.type.code=TSER5",
  linkToolsFr:
    "https://montreal.ca/services?mtl_content.services.type.code=TSER5",
  gridLink:
    "https://api.montreal.ca/api/housing/social-housing/contributions/v1/documents/contribution-grid",
  host: "https://api.montreal.ca/api/housing/social-housing/contributions/v1/",
};
